import { TeamContext } from "@redotech/redo-web/context/team-context";
import { memo, useContext } from "react";
import { SetupGuideHeaderTab } from "./components/header-tab/setup-guide-header-tab";
import { useSetupGuideOptional } from "./provider/use-setup-guide";
import { computeOverallProgress } from "./registry/helpers";
import { getProductConfig } from "./registry/product-registry";

/**
 * Mounts inside the merchant top nav. Renders the inline button only
 * when:
 *   - flag is on (provider context exists)
 *   - active product exists for this team
 *   - widget is collapsed/closed (otherwise the floating widget itself
 *     already shows the progress)
 *   - team isn't dismissed for this product
 */
export const SetupGuideNavButton = memo(function SetupGuideNavButton() {
  const setupGuide = useSetupGuideOptional();
  const team = useContext(TeamContext);

  if (!setupGuide || !team) return null;
  const { activeProduct, activeProgress, widget } = setupGuide;
  if (!activeProduct || !activeProgress) return null;
  if (widget.dismissedForTeam) return null;
  if (widget.visualState === "expanded") return null;

  const config = getProductConfig(activeProduct);
  if (!config) return null;
  const progress = computeOverallProgress(config, team, activeProgress);

  return (
    <SetupGuideHeaderTab
      onClick={widget.setExpanded}
      productDisplayName={config.displayName}
      progress={progress}
    />
  );
});
